import { HTMLAttributes } from "react";

export default function MongoDB(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.0143 16.0545C33.6161 17.7956 34.0496 19.5731 34.1921 21.4155C34.3691 23.7011 34.2881 25.9706 33.8063 28.2188C33.7931 28.2806 33.7654 28.3388 33.7448 28.3988C33.5936 28.3991 33.4395 28.3804 33.2918 28.4032C32.0434 28.5994 30.7961 28.8026 29.5489 29.0048C28.2596 29.2136 26.9685 29.4142 25.6815 29.6374C25.2255 29.7161 24.6611 29.622 24.477 30.2528C24.4718 30.27 24.4193 30.273 24.3889 30.2827L24.4511 26.5136L24.3878 17.4191L24.9885 17.316C25.971 17.1551 26.9535 16.992 27.9368 16.8356C29.1101 16.6493 30.2846 16.4681 31.4588 16.2863C31.9766 16.2056 32.4953 16.1318 33.0143 16.0545Z"
        fill="#439934"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.1484 41.2702C22.5147 40.7254 21.8588 40.2045 21.2513 39.6315C17.9824 36.5482 15.5914 32.9194 14.4139 28.5442C14.0895 27.3401 13.8732 26.1165 13.8038 24.8722C13.755 24.0015 13.6845 23.1229 13.746 22.2566C13.9099 19.9526 14.2429 17.6707 14.9187 15.4515L14.9558 15.3998C15.0214 15.4871 15.1159 15.5644 15.1493 15.663C15.8089 17.6055 16.4637 19.5495 17.115 21.4946C19.1618 27.6071 21.2059 33.7211 23.256 39.8321C23.2962 39.9514 23.4 40.0493 23.4747 40.1569L23.1484 41.2702Z"
        fill="#45A538"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.0143 16.0545C32.4953 16.1318 31.9763 16.2056 31.4584 16.2855C30.2843 16.4674 29.1098 16.6485 27.9364 16.8349C26.9531 16.9913 25.9706 17.1544 24.9881 17.3153L24.3874 17.4184L24.3829 17.0265C24.363 16.7044 24.3289 16.3826 24.3251 16.0605C24.2993 14.0062 24.2831 11.952 24.2576 9.89775C24.2419 8.61187 24.2183 7.32637 24.192 6.04087C24.1759 5.24212 24.1586 4.443 24.1226 3.64538C24.1031 3.21675 24.0341 2.79038 24.006 2.36175C23.9903 2.11538 24.012 1.86713 24.0169 1.61963C24.3233 2.21325 24.6229 2.81138 24.9379 3.4005C25.4355 4.332 26.2283 5.01825 26.9419 5.76713C29.763 8.72662 31.7659 12.1676 33.0143 16.0545Z"
        fill="#46A037"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.3885 30.2824C24.4189 30.2726 24.4717 30.2696 24.4766 30.2524C24.6607 29.6216 25.2251 29.7157 25.6811 29.637C26.9681 29.4142 28.2592 29.2133 29.5485 29.0044C30.7957 28.8023 32.043 28.599 33.2914 28.4029C33.4391 28.3796 33.5932 28.3987 33.7444 28.3984C33.5111 29.2309 33.3274 30.0814 33.0315 30.891C32.6955 31.8094 32.289 32.7056 31.8574 33.5842C31.2112 34.8948 30.4114 36.1238 29.475 37.2454C28.7554 38.1109 27.9532 38.9108 27.1492 39.7009C26.7049 40.1378 26.181 40.4936 25.6935 40.8862L25.5671 40.8L25.1119 40.4107L24.6409 39.3784C24.3191 38.1741 24.1436 36.9354 24.1181 35.6891L24.1267 35.4788L24.1909 34.569C24.2122 34.2585 24.2407 33.9484 24.2539 33.6371C24.3022 32.5189 24.3442 31.4006 24.3885 30.2824Z"
        fill="#409433"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.3885 30.2824C24.3442 31.4006 24.3022 32.5189 24.2546 33.6375C24.2415 33.9487 24.213 34.2589 24.1916 34.5694L23.9047 34.6777C23.2676 32.802 22.6301 30.9461 22.0065 29.0854C20.9752 26.007 19.9564 22.9237 18.9266 19.8446C18.0949 17.3593 17.2574 14.8759 16.4141 12.3945C16.3747 12.2782 16.2615 12.1875 16.1827 12.0847L18.0187 8.709C18.0817 8.8185 18.165 8.92087 18.2047 9.03862C19.0551 11.5519 19.9011 14.0667 20.7427 16.5829C21.8362 19.8566 22.923 23.133 24.0157 26.4071C24.0592 26.538 24.1312 26.6588 24.1999 26.8054L24.4511 26.5129L24.3885 30.2824Z"
        fill="#4FAA41"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1831 12.0851C16.2619 12.1879 16.3747 12.2786 16.4145 12.3949C17.2578 14.8763 18.0953 17.3597 18.927 19.845C19.9567 22.9241 20.9756 26.0074 22.0069 29.0857C22.6301 30.9461 23.2676 32.8024 23.9051 34.6781L24.192 34.5697L24.1279 35.4795L24.0697 35.6891C23.97 36.6851 23.886 37.6834 23.7645 38.6771C23.7034 39.1751 23.5736 39.6641 23.475 40.1572C23.4007 40.0496 23.2965 39.9517 23.2564 39.8325C21.2062 33.7211 19.1621 27.6075 17.1154 21.495C16.4642 19.5497 15.809 17.6059 15.1496 15.6634C15.1162 15.5647 15.0221 15.4875 14.9561 15.4001L16.1831 12.0851Z"
        fill="#4AA73C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4507 26.5133L24.1995 26.8057C24.1309 26.6591 24.0589 26.538 24.0154 26.4075C22.923 23.1334 21.8359 19.857 20.7424 16.5833C19.9007 14.067 19.0547 11.5523 18.2044 9.039C18.165 8.92125 18.0817 8.8185 18.0184 8.70937L20.289 5.7225C20.3606 5.81812 20.4626 5.90325 20.4997 6.01087C21.1301 7.85625 21.7549 9.70387 22.3759 11.5526C22.956 13.2791 23.5275 15.0082 24.1144 16.7325C24.1537 16.848 24.2906 16.9297 24.3821 17.0272L24.3866 17.4191C24.4084 20.4499 24.4297 23.4818 24.4507 26.5133Z"
        fill="#57AE47"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.3829 17.0265C24.2914 16.929 24.1545 16.8472 24.1151 16.7317C23.5282 15.0075 22.9567 13.2784 22.3766 11.5519C21.7556 9.70312 21.1309 7.85587 20.5005 6.01012C20.4634 5.9025 20.3614 5.81737 20.2897 5.72175C21.0281 4.99875 21.7436 4.24987 22.5116 3.56025C23.1945 2.9475 23.7435 2.2905 23.7686 1.32225C23.7697 1.28212 23.7907 1.242 23.823 1.1295L24.0176 1.61925C24.0127 1.86712 23.9906 2.115 24.0067 2.36137C24.0349 2.79 24.1039 3.21637 24.1234 3.645C24.1594 4.44262 24.1766 5.24175 24.1927 6.0405C24.2186 7.326 24.2422 8.6115 24.2584 9.89738C24.2835 11.9516 24.3 14.0059 24.3259 16.0601C24.3289 16.383 24.3626 16.7044 24.3829 17.0265Z"
        fill="#60B24F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4743 40.1569C23.5729 39.6637 23.7026 39.1744 23.7638 38.6768C23.8856 37.6834 23.9693 36.6847 24.069 35.6887L24.0938 35.685L24.1185 35.6891C24.144 36.9354 24.3195 38.1741 24.6413 39.3784C24.5753 39.4654 24.4819 39.543 24.447 39.6412C24.1744 40.41 23.9175 41.1847 23.6434 41.9535C23.6059 42.0585 23.5016 42.1403 23.4281 42.2325L23.148 41.2703L23.4743 40.1569Z"
        fill="#A9AA88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4285 42.2329C23.502 42.1406 23.6067 42.0589 23.6438 41.9539C23.9179 41.1851 24.1752 40.4107 24.4474 39.6416C24.4823 39.5434 24.5753 39.4657 24.6417 39.3787L25.1123 40.4115C25.0193 40.5435 24.891 40.6624 24.8393 40.8094L23.9378 43.4565C23.9007 43.5626 23.7739 43.6376 23.6892 43.7273L23.4285 42.2329Z"
        fill="#B6B598"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6891 43.7269C23.7743 43.6376 23.9006 43.5623 23.9378 43.4561L24.8393 40.809C24.8906 40.6624 25.0193 40.5431 25.1123 40.4111L25.5679 40.8C25.3478 41.0175 25.2255 41.2688 25.299 41.5864L25.1606 42.0394C25.0976 42.117 25.0065 42.1845 24.9754 42.2734C24.6608 43.1745 24.3604 44.0805 24.0435 44.9816C24.0034 45.096 23.892 45.1856 23.8133 45.2861C23.7724 44.766 23.7308 44.247 23.6891 43.7269Z"
        fill="#C2C1A7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8137 45.2861C23.892 45.1852 24.0034 45.0956 24.0439 44.9816C24.3608 44.0809 24.6612 43.1749 24.9758 42.2734C25.0069 42.1849 25.0977 42.117 25.161 42.0394L24.9702 44.1187C24.9192 44.1776 24.8453 44.229 24.8209 44.2976C24.6053 44.9029 24.402 45.5126 24.1857 46.1179C24.141 46.2428 24.0555 46.353 23.9888 46.4696C23.9295 46.392 23.8234 46.317 23.8185 46.236C23.7994 45.9206 23.8125 45.603 23.8137 45.2861Z"
        fill="#CECDB7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9884 46.4696C24.0552 46.3526 24.1407 46.2424 24.1853 46.1179C24.402 45.513 24.6049 44.9033 24.8205 44.2976C24.8449 44.229 24.9192 44.178 24.9698 44.1188L24.9743 45.4838L24.5175 46.6553L23.9884 46.4696Z"
        fill="#DBDAC7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.5175 46.6556L24.9743 45.4841L25.0684 46.8701L24.5175 46.6556Z"
        fill="#EBE9DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.299 41.5868C25.2255 41.2691 25.3474 41.0175 25.5679 40.8004L25.6943 40.8866L25.299 41.5868Z"
        fill="#CECDB7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1185 35.6895L24.0938 35.6854L24.069 35.6891L24.1272 35.4795L24.1185 35.6895Z"
        fill="#4FAA41"
      />
    </svg>
  )
}
